import React from 'react'
import '../../sassFiles/errorpages/notFoundPage.scss'
import { Link } from 'react-router-dom'
const CancelPage = () => {
  return (
    <>
        <div className="desktop">
        <div className="cancelpage" style={{height:"100vh",width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}>
           
            <div className='cancelwrap text-center'>
           <h2>Cancelled</h2>
            <Link to="/trackadmission">Go To Track Admission</Link>

            </div>

           
        </div>

    </div>
    </>
  )
}

export default CancelPage